import React from 'react';
import { Box, Flex, Heading } from "@chakra-ui/react";
import { useAppSelector } from "../../redux/hooks";
import { resolveSiteSeoFooter } from "../../utils/tenancySeo";

const Footer = () => {
    const { tenancyConfigData } = useAppSelector((state) => ({
        tenancyConfigData: state.affiliate.multiTenancyConfigData,
    }));
    const brandSearchLine = resolveSiteSeoFooter(tenancyConfigData);

    return (
    <Flex mt="auto" direction="column">
        <Heading
            as="p"
            size="md_light"
            textTransform="initial"
            color='#605E5C'
            mt="3.2rem"
        >
            Mito.money is a trademark owned by Funtech Global Communications Ltd. Devonshire House, Manor way, Borehamwood, Herts. WD6 1QQ, United Kingdom. A registered Payment institution in the UK with registration details FRN: 815146 MLR NO: 12803115
        </Heading>
        {brandSearchLine && (
          <Box
            as="footer"
            role="contentinfo"
            mt="4"
            py="2"
            px="3"
            bg="#1b1c1d"
            borderTop="1px solid rgba(255, 255, 255, 0.08)"
            textAlign="center"
            fontSize="0.7rem"
            lineHeight="1.35"
            color="rgba(208, 217, 221, 0.65)"
          >
            {brandSearchLine}
          </Box>
        )}
    </Flex>
    );
};

export default React.memo(Footer);
            